'use strict';

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var $ = require('jquery');
var View = require('./item').default;

export default Marionette.CollectionView.extend({

  tagName: 'ul',
  className: 'language-picker-list',
  childView: View,
  events: {
    'click a': 'onClickItem',
  },

  initialize: function (options) {
    options = options || {};

    this.collection = options.collection;
  },

  onClickItem: function (evt) {
    evt.preventDefault();
    var lang = evt.target.href.substr(evt.target.href.indexOf('#') + 1);
    if (this.collection.getCurrent() != lang) {
      this.collection.setCurrent(lang);
    }
  },

});
